<template>
  <div id="app">   
    <router-view :key="$route.params.slug || 'default'" v-slot="{ Component }">
      <transition name="fade" mode="out-in">
          <component :is="Component" />
      </transition>
    </router-view>    
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #FCFCFC !important;
}

.space-below {
  padding-bottom: 3.5rem;
}

.add-goal {
  font-size: 2em !important;
  background-color: #4AB563 !important;
  border-color: #4AB563 !important;
}

.spinner-border {
  width: 1.2em !important;
  height: 1.2em !important;
  border-width: 0.15em !important;
}

.player-info-container {
  min-height: 80px;
}

.link-button {
  cursor: pointer;
}

.match-entry {
  cursor: pointer;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.match-result {
  white-space: nowrap;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.flip-list-move {
  transition: transform 0.4s ease;
}

.back-icon {
  margin-top: -4px;
  margin-right: 5px;
}

.nounderline {
  text-decoration: none !important;
}

.nounderline:hover {
  text-decoration: underline;
}

.max-width-form  {
  max-width: 350px !important;
}

</style>
